// user utilities
import { UserDB } from "app/models";

export function isUserInStandardMode(user: UserDB) {
    if (user.mode === 'standard') {
        return true;
    }

    return false;
}
